import React from 'react';

import {makeStyles} from "@mui/styles";
import {IntegrationsSidebar} from "./IntegrationsSidebar";
import {Route, Switch} from "react-router";
import {Routes} from "../../constants/Routes";
import {IntegrationAuthWrapper} from "./IntegrationAuthWrapper";
import {IntegrationAuthEditor} from "./IntegrationAuthEditor";
import {IntegrationEditAuthFields} from "./auth/IntegrationEditAuthFields";
import {IntegrationAddAuthFields} from "./auth/IntegrationAddAuthFields";
import {IntegrationTriggersListRoot} from "./triggers/IntegrationTriggersListRoot";
import {IntegrationTriggerEditor} from './triggers/IntegrationTriggerEditor';
import {IntegrationActionsListRoot} from "./actions/IntegrationActionsListRoot";
import {IntegrationEventsAdd} from "./IntegrationEventsAdd";
import {IntegrationActionEditor} from './actions/IntegrationActionEditor';
import {IntegrationEdit} from "./IntegrationEdit";

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        height: "100%",
        overflow: "hidden"
    },
    content: {
        flex: "1 1",
        overflow: "auto"
    }
}));

export function IntegrationEditorRoot() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <IntegrationsSidebar/>
            <div className={classes.content}>
                <Switch>
                    {/*<Route path={Routes.IntegrationEditorHome} exact render={() => <h1>IntegrationEditorHome</h1>}/>*/}
                    <Route path={Routes.IntegrationEdit} exact render={() => <IntegrationEdit/>}/>
                    {/*--------------AUTH----------*/}
                    <Route path={Routes.IntegrationEditorAuth} exact component={IntegrationAuthWrapper}/>
                    <Route path={Routes.IntegrationEditorAuthEdit} exact component={IntegrationAuthEditor}/>
                    <Route path={Routes.IntegrationEditorAuthFieldsAddEdit} exact
                           component={IntegrationEditAuthFields}/>
                    <Route path={Routes.IntegrationEditorAuthFieldsAdd} exact component={IntegrationAddAuthFields}/>
                    {/*--------------TRIGGER----------*/}
                    <Route path={Routes.IntegrationEditorTrigger} exact component={IntegrationTriggersListRoot}/>
                    <Route path={Routes.IntegrationEditorTriggerAdd} exact
                           render={() => <IntegrationEventsAdd isTrigger/>}/>
                    <Route path={Routes.IntegrationEditorTriggerEditor} exact component={IntegrationTriggerEditor}/>
                    {/*-------------ACTIONS----------*/}
                    <Route path={Routes.IntegrationEditorAction} exact component={IntegrationActionsListRoot}/>
                    <Route path={Routes.IntegrationEditorActionsEditor} exact
                           render={() => <IntegrationActionEditor/>}/>
                    <Route path={Routes.IntegrationEditorActionAdd} exact
                           render={() => <IntegrationEventsAdd isTrigger={false}/>}/>
                </Switch>
            </div>
        </div>
    );
}

